package com.mgacreative.hotelru.feature.admin.di

import com.mgacreative.hotelru.feature.admin.ui.*
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getAdminFeatureModule() = module {
    viewModel { AdminViewModel(get(), get()) }
    viewModel { AdminRoomViewModel(get(), get()) }
    viewModel { AdminPricingViewModel(get(), get(), get()) }
    viewModel { AdminSupplierViewModel(get()) }
    viewModel { AdminAgencyViewModel(get()) }
    viewModel { AdminDepartmentViewModel(get()) }
    viewModel { AdminStaffViewModel(get(), get()) }
    viewModel { AdminBlacklistViewModel(get()) }
    viewModel { AdminMenuViewModel(get()) }
    viewModel { AdminMembersViewModel(get(), get()) }
}

